import { isNotNil } from '../../isNotNil';
import { localStorageBridge } from '../../bridge/localStoragebridge';

/**
 * 웹뷰로 열 절대 URL 의 origin 을 반환합니다.
 * - 웹: 현재 origin (이미 해당 스테이지 도메인에서 서빙되므로 그대로 사용)
 * - 네이티브: localStorage 의 `stage` 값으로 스테이징(`m-<stage>`) / 프로덕션(`m`) 구분.
 *   `getAPIHost` 와 동일한 stage 소스를 사용해, 베타/스테이징에서 prod 도메인으로
 *   하드코딩되던 문제를 막습니다.
 */
export const getWebviewOrigin = async (): Promise<string> => {
  const stage = await localStorageBridge.getString('stage');
  return isNotNil(stage) && stage !== 'prod'
    ? `https://m-${stage}.a-bly.com`
    : 'https://m.a-bly.com';
};

/**
 * RN 기본 Deeplink 형식을 만듭니다
 */
export const getDefaultDeeplink = () => {
  return buildUrl('ably://react/App');
};

/**
 * 기본 WebView link를 만듭니다
 * @param titleBar
 */
export const getDefaultWebviewLink = (titleBar?: boolean) => {
  const link = buildUrl('ably://webview');
  if (isNotNil(titleBar)) {
    appendParams(link, 'title_bar', titleBar ? 'true' : 'false');
  }
  return link;
};

/**
 * Path를 URL class로 변경합니다
 * @param path
 */
export const buildUrl = (path: string) => {
  return new URL(path);
};

/**
 * 필요한 Params를 추가합니다
 * @param url
 * @param name
 * @param value
 */
export const appendParams = (url: URL, name: string, value: string) => {
  return url.searchParams.set(name, value);
};

/**
 * 딥링크 동작시키기 전, 필요한 처리를 합니다
 * @param url
 */
export const finalizeUrl = (url: URL) => {
  return url.href.replaceAll('+', '%20');
};
